import { Typography } from "@mui/material";
import React from "react";

const Footer = () => {
   return (
      <Typography
         variant="p"
         component="p"
         bgcolor="#f7f7f7"
         color="primary"
         textAlign="center"
         mt={10}
         p="10px"
      >
         ساخته شده با ❤️
      </Typography>
   );
};

export default Footer;
